module.exports = __webpack_public_path__ + "media/images/businessCard-3c14f0edbe177e2d74f166b91dd3d79c.jpg";